export default __webpack_public_path__ + "static/media/beatboy4.82431986.gif";